import {createSelector} from 'reselect';

export const selectNotes = (state) => state.get('notes');

export const makeSelectNotes = () =>
  createSelector(selectNotes, (NotesState) => NotesState.get('notes').toJS());
